<template>
  <div id="app">
    <loader>

      <router-view/>
    </loader>
  </div>
</template>
<script>
    import Loader from './components/common/Loader';
    import EventBus from './event-bus.js';


    export default {
        name: 'App',
        metaInfo: {
            title: 'Главная',
            titleTemplate: '%s | #отфудбольизжогу'
        },
        components: {
            Loader,
        },
        mounted() {
            setTimeout(() => {
                EventBus.$emit('end-loading');
            }, 1000);

        }
    }
</script>

<style lang="scss">
  @import "~normalize-scss/fork-versions/default/normalize";
  @import "./assets/scss/transitions";
  @import url('https://fonts.googleapis.com/css?family=Roboto:100,400,700&subset=cyrillic,cyrillic-ext');

  #app {
    font-family: 'Roboto', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #ffffff;
    position: relative;
    #silentbox-overlay{
      position: absolute;
    }
    /*#silentbox-overlay__embed{*/
      /*width: 90%;*/
    /*}*/
  }

  div {
    overflow: visible;
  }

  .button {
    background: #5f2764; /* Old browsers */
    background: -moz-linear-gradient(left, #5f2764 0%, #f43e71 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(left, #5f2764 0%, #f43e71 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to right, #5f2764 0%, #f43e71 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#5f2764', endColorstr='#f43e71', GradientType=1); /* IE6-9 */
    transition: all ease-in-out 100ms;
    color: #ffffff;
    font-size: 20px;
    font-weight: 300;
    line-height: 58px;
    text-align: center;
    width: 269px;
    height: 58px;
    border-radius: 60px;
    display: block;
    text-decoration: none;
    margin: 0 auto;
    &:hover {
      /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#f43e71+0,5f2764+100 */
      background: #f43e71; /* Old browsers */
      background: -moz-linear-gradient(left, #f43e71 0%, #5f2764 100%); /* FF3.6-15 */
      background: -webkit-linear-gradient(left, #f43e71 0%, #5f2764 100%); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(to right, #f43e71 0%, #5f2764 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f43e71', endColorstr='#5f2764', GradientType=1); /* IE6-9 */
      transform: scale(1.02);
    }
    &.button-inverted {
      background: #17294d;
      background: -moz-linear-gradient(left, #17294d 0%, #128783 99%);
      background: -webkit-linear-gradient(left, #17294d 0%, #128783 99%);
      background: linear-gradient(to right, #17294d 0%, #128783 99%);
      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#17294d', endColorstr='#128783', GradientType=1);

       &:hover {
         background: #128783; /* Old browsers */
         background: -moz-linear-gradient(left, #128783 1%, #17294d 100%); /* FF3.6-15 */
         background: -webkit-linear-gradient(left, #128783 1%, #17294d 100%); /* Chrome10-25,Safari5.1-6 */
         background: linear-gradient(to right, #128783 1%, #17294d 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
         filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#128783', endColorstr='#17294d', GradientType=1); /* IE6-9 */

       }
    }
  }
  @media screen and (max-width: 768px){
    .button{
      width: 150px;
      height: 32px;
      line-height: 32px;
      font-size: 12px;
    }
  }
</style>
